"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JoinIcon = void 0;
var ToggleMenuFlyoutEvent = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../../../api");
var _navigation = require("../../../../context/navigation");
var _hooks = require("../../../../hooks");
var _utils = require("../../../../utils");
var _constants = require("../../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const JoinIcon = ({
  variant = 'text'
}) => {
  const {
    isUserVerified,
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    joinLabel,
    joinUrl,
    loading
  } = (0, _navigation.useLabels)();
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    data: items
  } = (0, _api.useGetNavigationType)({
    type: 'JoinTiles',
    enabled: isAnonymousUser && isUserVerified
  });
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const handleClick = (0, _react.useCallback)(() => (0, _utils.dispatchToggleMenu)(ToggleMenuFlyoutEvent.MenuTypes.JoinMenu), []);
  if (loading || !isUserVerified) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.JoinSkeleton, {
      "data-testid": getTestId(_constants.JOIN_SKELETON),
      variant: "rectangular",
      height: 21,
      width: 120
    });
  }
  if (items.length > 0 && !isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.JoinLabel, {
      disableRipple: true,
      as: _mui.ButtonBase,
      "data-testid": getTestId(_constants.JOIN_LABEL),
      onClick: handleClick,
      children: joinLabel
    });
  }
  if (joinUrl && variant === 'smallButton') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledButton, {
      "data-testid": getTestId(_constants.JOIN_BUTTON),
      variant: "outlined",
      size: "small",
      href: joinUrl,
      children: joinLabel
    });
  } else if (joinUrl) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.JoinLabel, {
      href: joinUrl,
      children: joinLabel
    });
  }
  return null;
};
exports.JoinIcon = JoinIcon;
//# sourceMappingURL=JoinIcon.js.map